import { Button } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { Row, Col,  } from 'antd';
import { useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';
import constants from '../../constants/constants';
import { CommonContext } from '../../Context';

const ChatBotCareer = (props) => {
  const history = useHistory();
  const [jobExists,setJobExists]=useState(props?.jobExists);
  const [countrycode,setCountryCode]=useState(props?.countrycode);
  const commonContext=useContext(CommonContext);
  const [buyerID,setBuyerId]=useState(props?.jobExists===true?commonContext.common.buyerId:555)

  useEffect(() => {
    let buyerId=buyerID;
    let bottype="";
    if(props?.jobExists===true){
      bottype="company-"+buyerId;
    }else{
      bottype="company-"+555; 
    }
    const script = document.createElement('script');
    script.src = 'https://images.applygateway.com/chatjs/CompanyChatInclude.js?t=123';
    script.setAttribute('data-buyerid', buyerId);
    script.setAttribute('data-countrycode', countrycode);
    script.setAttribute('data-bottype', bottype);
    script.async = true;
    script.defer = true;
    script.id = 'career-script';
    document.body.appendChild(script);

    return () => {
      window?.voiceflow?.chat?.destroy();
      document.body.removeChild(script);
    };
  }, [jobExists,countrycode]);

  const RedirectChatBotDomain=()=>{
    history.push("/chatbotdomainconfigure")
  };

  return  (
    <div>
      <Row style={{ height: '100%' }}>
        <Col span={12} >
          {jobExists===true?
          <div>
          <p className='font-bold text-xs'>
            The careers Site - Talent Manager bot can be placed on your company Careers Site or General Website.
          </p>
          <br/>
          <p className='font-bold text-xs'>
            You can configure it with pages of your Carrers site or Upload text information and it will learn from all the uploaded data and is able to answer questions about working at your company.
          </p>
          <br/>
          <p className='font-bold text-xs'>
            It will also index all your live jobs which can be searched and applied to.
          </p>
          <br/>
          </div>:
          <div>
          <p className='font-bold text-xs'>
            Chat Bot has not been added in as a supplier on this account. Contact your CS rep to add it in.
          </p>
          <br/>
          <p className='font-bold text-xs'>
            These test jobs are loaded from another account.
          </p>
          <br/>
          </div>}
          <div className="flex items-center justify-center">
          <Button className='uppercase ' onClick={()=>RedirectChatBotDomain()}>Configure Learning</Button>
          </div>
        </Col>

        <Col span={12} style={{ backgroundColor: '#fff' }}>
          {/* You can add content here later */}
        </Col>
      </Row>
    </div>
  );
};

export default ChatBotCareer;